import * as actionTypes from '../actions';

const initialState = {
    registration: {
        isValid: true,
        isEmailAuthenticated: false,
        showAdditionalFields: false,
        isSubmitted: false,
        locked: false,
        formFields: {
            firstName: {
                value: "",
            },
            lastName: {
                value: "",
            },
            email: {
                value: "",
            },
            phoneNumber: {
                value: "",
            },
            numberAdvisors: {
                value: "SELECT",
            },
            numberClients: {
                value: "SELECT",
            }
        },
        advisorInfo: {
            advisorId: null,
            personId: null
        }
    }
};


const updateAdvisorInfo = (state, data) => {
    let newState = Object.assign({}, state);

    newState.registration.advisorInfo = {
        advisorId: data.advisorId,
        personId: data.personId
    };

    newState.registration.isSubmitted = true;

    return newState;
};

const verifiedEmailAddressUpdate = (state, action) => {
    let email = action.data;
    let newState = Object.assign({}, state);
    newState.registration.formFields.email = Object.assign({}, state.registration.formFields.email);
    newState.registration.formFields.email.value = email;
    newState.registration.isSubmitted = true;

    return newState;

};

const lockRegistration = (state) => {
    let newState = Object.assign({}, state);
    newState.registration.locked = true;
    return newState;
};

const unLockRegistration = (state) => {
    let newState = Object.assign({}, state);
    newState.registration.locked = false;
    return newState;
};


const registrationReducer = (state = initialState, action) => {
    if(action.type === actionTypes.REGISTRATION_UPDATE_EMAIL) {
        let email = action.email;
        let newState = Object.assign({}, state);
        newState.registration.formFields.email = Object.assign({}, state.registration.formFields.email);
        newState.registration.formFields.email.value = email;
        newState.registration.showAdditionalFields = true;
        return newState;
    }

    if (action.type === actionTypes.REGISTRATION_UPDATE_ADVISOR_DETAILS) {
        let newState = Object.assign({}, state);
        let formFields = action.data.formFields;

        newState.registration.formFields = {
            firstName: {
                value: formFields.firstName.value,
            },
            lastName: {
                value: formFields.lastName.value,
            },
            email: {
                value: newState.registration.formFields.email.value,
            },
            phoneNumber: {
                value: formFields.phoneNumber.value,
            },
            numberAdvisors: {
                value: formFields.numberAdvisors.value,
            },
            numberClients: {
                value: formFields.numberClients.value,
            }
        };

        return newState;
    }

    if (action.type === actionTypes.UPDATE_ADVISOR_DATA) {
        return updateAdvisorInfo(state, action.data);
    }

    if (action.type === actionTypes.REGISTRATION_UPDATE_EMAIL_EXISTS) {
        return verifiedEmailAddressUpdate(state, action);
    }

    if (action.type === actionTypes.LOCK_REGISTRATION) {
        return lockRegistration(state);
    }

    if (action.type === actionTypes.UNLOCK_REGISTRATION) {
        return unLockRegistration(state);
    }

    return state;
};

export default registrationReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/registration.js